export enum ENavigateKey {
  Home = '/',
  BlogSignle = '/blog',
  Photography = '/photography',
  MakeupAndHair = '/makeup-and-hair',
  Portfolio = '/portfolio',
  ContactUs = '/contact-us',
  GalleryDetail = '/gallery-detail',
}
